module.exports = __webpack_public_path__ + "img/logo copy.a5d6fa57.png";